import PropTypes from 'prop-types';
import React from 'react';

export class GroupListItem extends React.Component {
  render() {
    let itemClass = 'list-group-item';
    itemClass += this.props.understated ? ' understated' : '';

    const buttonClass = itemClass + (this.props.selected ? ' active' : '');

    const indicatorCss = 'fa fa-circle icon-circle' + (this.props.isNew ? '' : ' hidden');

    return (
      <li className={ itemClass } key={ this.props.index }>
        <button
          type="button"
          className={ buttonClass }
          onClick={ this.props.clickHandler }
        >
          <span className="glyphicon glyphicon-menu-right chevron visible-xs-inline visible-sm-inline"></span>
          <span className={ indicatorCss }></span>
          <span className="primary-text">{this.props.title}</span>
        </button>
      </li>
    );
  }
}

GroupListItem.propTypes = {
  isNew: PropTypes.bool,
  title: PropTypes.string,
  understated: PropTypes.bool,
  index: PropTypes.number,
  selected: PropTypes.bool,
  clickHandler: PropTypes.func,
};
